import PropTypes from 'prop-types';
import {
  DrawerContainer, Overlay,
} from './styles';

export default function Drawer({ isOpen, onClose, children }) {
  return (
    <Overlay isOpen={isOpen} onClick={() => onClose()}>
      <DrawerContainer isOpen={isOpen} onClick={(event) => event.stopPropagation()}>
        {children}
      </DrawerContainer>
    </Overlay>
  );
}

Drawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

Drawer.defaultProps = {
  children: null,
};
